import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import ServicesOverview from "./components/ServicesOverview";
import AIAnswerBlock from "./components/AIAnswerBlock";
import ProcessSection from "./components/ProcessSection";
import WhyChooseUs from "./components/WhyChooseUs";
import ServiceAreas from "./components/ServiceAreas";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import FinalCTA from "./components/FinalCTA";
import MidPageCTA from "./components/MidPageCTA";
import QuoteForm from "./components/QuoteForm";
import { homeFaqs } from "@/mocks/faqs";

const homeQA = [
  {
    q: "What does Knight In Shining Armor Heating & Air (KISA) do?",
    a: "KISA provides professional AC repair, installation, and maintenance for homes and businesses across McKinney, Dallas, and the DFW metro. Every service is focused on system efficiency, reliability, and long-term performance in the extreme Texas heat.",
  },
  {
    q: "What makes KISA different from other HVAC companies in Dallas?",
    a: "KISA combines rapid response times, certified technicians, and performance-driven solutions designed to extend system lifespan and reduce energy costs. Every recommendation is transparent and honest — built for long-term results, not quick fixes.",
  },
];

export default function Home() {
  return (
    <main className="bg-[#020B14]">
      <Header />
      <HeroSection />
      <TrustBar />
      <ServicesOverview />
      <MidPageCTA />
      <AIAnswerBlock items={homeQA} title="About KISA Cooling Dallas" />
      <ProcessSection />
      <WhyChooseUs />
      <ServiceAreas />
      <TestimonialsSection />
      <QuoteForm />
      <FAQSection faqs={homeFaqs} title="Dallas AC Service — Common Questions" />
      <FinalCTA />
      <Footer />
    </main>
  );
}
